import React from "react";
import "../../../styles/TicketPrices.scss";

interface Seat {
  seat_number: string;
  is_available: boolean;
}

interface Ticket {
  id: string;
  event_id: string;
  name: string;
  description: string;
  capacity: number;
  ticket_price: string;
  created_at: string;
}

interface Props {
  tickets: Ticket[];
  all_dates: string[] | null;
}

const formatTimeTo12Hour = (datetime: string): string => {
  const d = new Date(datetime);
  return d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const TicketPrices: React.FC<Props> = ({ tickets,  all_dates  }) => (
  <div className="ticket-prices">
    <div className="ticket-header">
      <span>Ticket Type</span>
      <span>Available Time</span>
      <span>Price</span>
    </div>
    {tickets.map((ticket, index) => (
      <div className="ticket-row" key={index}>
        <span>{ticket.name}</span>
          <span>
          {all_dates && all_dates.length > 0
            ? formatTimeTo12Hour(all_dates[0])
            : "—"}
        </span>
        <span>₱{parseFloat(ticket.ticket_price).toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
      </div>
    ))}
  </div>
);

export default TicketPrices;
